/* eslint-disable consistent-return */
import React, { useState, useRef, useEffect } from 'react';
import Loader from '../../Common/Loader';
import Filter from './Filter';
import moment from 'moment-timezone';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import constants from '../../../constants';
import { cookieStorageUtility } from '../../../utils/utilityFunctions';

import ReactPaginate from 'react-paginate';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const ActivityLogWrapper = () => {
  // State hooks
  const [list, setList] = useState([]);
  const [activities, setActivities] = useState([]);
  const [activityDetail, setActivityDetail] = useState([]);
  const [csv, setCsv] = useState([]);
  const [show, setShow] = useState(false);
  const [showUILoader, setShowUILoader] = useState(false);
  const [limit] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageRangeDisplayed] = useState(5);
  const [counter, setCounter] = useState(0);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [searchParam, setSearchParam] = useState({
    hotelId: '',
    activity: '',
    date: ''
  });

  // Ref
  const csvRef = useRef();

  // useEffect equivalent of componentDidMount
  useEffect(() => {
    getActivityList();
  }, []);

  // Message handler
  const setMessageFunc = (messageType, messageText) => {
    setFlag(true);
    setType(messageType);
    setMessage(messageText);
    setTimeout(() => {
      setFlag(false);
    }, 3000);
  };

  // Get activity logs
  const getActivityLogs = () => {
    setShowUILoader(true);
    
    const requestPayload = {
      page: pageNumber,
      limit: limit,
      searchParam: searchParam
    };

    axios(serverUrl + 'logs/getactivitylogs', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: requestPayload
    })
      .then(response => {
        if (response.data.status === 'success') {
          // Ensure data is properly structured
          const responseData = response.data.data || [];
          const responseCount = response.data.count || 0;
          
          setList(responseData);
          setTotal(responseCount);
        } else {
          setMessageFunc('error', response.data.message || 'Failed to fetch activity logs');
          setList([]);
          setTotal(0);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.error('Activity logs API error:', error);
        setMessageFunc('error', 'Network error occurred while fetching activity logs');
        setList([]);
        setTotal(0);
        setShowUILoader(false);
      });
  };

  // Get activity list
  const getActivityList = () => {
    axios(serverUrl + 'common/activitymaster', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      }
    })
      .then(response => {
        if (response.status === 200) {
          const activityMaster = response.data?.data?.activityMaster || [];
          setActivities(activityMaster);
        } else {
          setMessageFunc('error', response.data?.message || 'Failed to fetch activities');
        }
      })
      .catch(error => {
        console.error('Activity master API error:', error);
        setMessageFunc('error', 'Network error occurred while fetching activities');
      });
  };

  // Get details
  const getDetails = (id) => {
    setShowUILoader(true);
    
    axios(serverUrl + 'logs/logDetail', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { log_id: id }
    })
      .then(response => {
        setShow(true);
        if (response.status === 200) {
          setActivityDetail(response.data.data || []);
        } else {
          setMessageFunc('error', response.data?.message || 'Failed to fetch log details');
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.error('Log detail API error:', error);
        setMessageFunc('error', 'Network error occurred while fetching log details');
        setShowUILoader(false);
      });
  };

  // Render activity logs list
  const renderActivityLogsList = () => {
    if (!list || Object.keys(list).length === 0) {
      return null;
    }

    return Object.keys(list).map(id => {
      const data = list[id];
      if (!data) return null;

      return (
        <div className="table_row border_t_1 border_color_1" key={id}>
          <div className="tabcel align_middle pad10">{data.user || ''}</div>
          <div className="tabcel align_middle pad10">{data.hotel || ''}</div>
          <div className="tabcel align_middle pad10">{data.activity_name || ''}</div>
          <div className="tabcel align_middle pad10">{data.description || ''}</div>
          <div className="tabcel align_middle pad10">{data.date || ''}</div>
          <div className="tabcel align_middle pad10 tu bld wdhpx20">
            {data.activity_id === 41 && (
              <a 
                onClick={() => getDetails(data.activity_log_id)} 
                className="inline align_middle" 
                href="#" 
                title="View details"
              >
                <i className="fa fa-eye"></i>
              </a>
            )}
          </div>
        </div>
      );
    });
  };

  // Activity details list
  const activityDetailsList = () => {
    if (!activityDetail || Object.keys(activityDetail).length === 0) {
      return null;
    }

    return Object.keys(activityDetail).map(key => {
      const detail = activityDetail[key];
      if (!detail || !detail.mapping) return null;

      return Object.keys(detail.mapping).map(key2 => {
        const mapping = detail.mapping[key2];
        return (
          <div className="table_row border_t_1 border_color_1" key={`${key}-${key2}`}>
            <div className="tabcel align_middle pad5">{mapping.cat_name || ''}</div>
            <div className="tabcel align_middle pad5">{mapping.markup_rate_per || ''}</div>
            <div className="tabcel align_middle pad5">{mapping.markup_rate_flat || ''}</div>
            <div className="tabcel align_middle pad5">{mapping.mini_rate_threshold || ''}</div>
            <div className="tabcel align_middle pad">{mapping.decrease_inventory || ''}</div>
            <div className="tabcel align_middle pad">{detail.user_name || ''}</div>
            <div className="tabcel align_middle pad">{detail.created_on || ''}</div>
          </div>
        );
      });
    });
  };

  // Handle page change
  const handlePageChange = (selectedPage) => {
    const newPageNumber = selectedPage.selected + 1; // ReactPaginate uses 0-based indexing
    const newCounter = newPageNumber <= 1 ? 0 : (newPageNumber - 1) * limit;
    
    setPageNumber(newPageNumber);
    setCounter(newCounter);
    
    // Call getActivityLogs after state is updated
    setTimeout(() => {
      getActivityLogs();
    }, 0);
  };

  // Date change handler
  const dateChange = (date, dateType) => {
    try {
      const newDate = moment(date).format('YYYY-MM-DD');
      const newSearch = { ...searchParam };
      newSearch[dateType] = newDate;
      setSearchParam(newSearch);
    } catch (error) {
      console.error('Date formatting error:', error);
      setMessageFunc('error', 'Invalid date format');
    }
  };

  // Parameter change handler
  const paramChange = (e, paramType) => {
    const newSearch = { ...searchParam };
    if (paramType === 'hotelName') {
      newSearch[paramType] = e.length > 0 ? e[0].hotel : '';
      newSearch['hotelId'] = e.length > 0 ? e[0].hotel_id : '';
    } else {
      newSearch[paramType] = e.target.value;
    }
    setSearchParam(newSearch);
  };

  // Search activity logs
  const searchActivityLogs = () => {
    let isValid = false;
    const msg = 'Please Select Criteria for search.';

    if (
      searchParam.hotelId !== '' ||
      searchParam.activity !== '' ||
      searchParam.date !== ''
    ) {
      isValid = true;
    }

    if (!isValid) {
      setMessageFunc('error', msg);
    } else {
      setPageNumber(1);
      setCounter(0);
      setTimeout(() => {
        getActivityLogs();
      }, 0);
    }
  };

  // Reset function
  const reset = () => {
    const newSearch = {
      hotelId: '',
      activity: '',
      date: ''
    };
    
    setList([]);
    setTotal(0);
    setPageNumber(1);
    setCounter(0);
    setSearchParam(newSearch);
  };

  // Download function (placeholder)
  const download = () => {
    // Implementation for download functionality
    console.log('Download functionality to be implemented');
  };

  return (
    <React.Fragment>
      {showUILoader && <Loader />}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">Activity Logs</div>
          </div>
          <div className="col-xs-auto hides" onClick={download}>
            <i className="fa fa-file-pdf-o cursor_p fnt20" />
          </div>
          <CSVLink data={csv} ref={csvRef} filename="bookings.csv" />
        </div>
      </div>
      {flag && (
        <div className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}>
          {message}
        </div>
      )}
      <Filter
        params={searchParam}
        dateChange={dateChange}
        paramChange={paramChange}
        searchActivityLogs={searchActivityLogs}
        activities={activities}
        reset={reset}
      />
      <div className="container_fluid pad_lft_rht20 padtop25 text-start">
        <div className="cover border_all_1 border_color_1">
          <div className="scrolly_auto">
            <div className="table_col table_fixed">
              <div className="table_row bg2_8">
                <div className="tabcel align_middle pad10 tu bld wdhpx220">User Name</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Hotel</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Activity</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Description</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx130">Date</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx20"></div>
              </div>
              {renderActivityLogsList()}
            </div>
          </div>
          {total === 0 && !showUILoader && (
            <div className="cover pad30 border_t_1 border_color_1">
              <div className="ovr tc marg_bottom10">
                <div className="inline">
                  <img src="/images/no_result.png" alt="No Logs Found" />
                </div>
              </div>
              <div className="ovr tc fnt16 bld">No Logs Found</div>
            </div>
          )}
        </div>
        {total > limit && (
          <div className="cover tc margtop15">
            <ReactPaginate
              breakLabel="..."
              nextLabel="Next >"
              onPageChange={handlePageChange}
              pageRangeDisplayed={2}
              pageCount={Math.ceil(total / limit)}
              previousLabel="< Prev"
              forcePage={pageNumber - 1}
              containerClassName="pagination"
              activeClassName="active"
              marginPagesDisplayed={0}
            />
          </div>
        )}
      </div>

      {/* popup */}
      <div className={`modal_wrap posfixed ${show ? '' : 'hides'}`}>
        <div className="modal_overlay transbg1">&nbsp;</div>
        <div className="pop_colum">
          <div className="pop_inner pad50">
            <div className="apndwrap shwd2 bg1 pad30 round5 ovr zIndex999">
              <div
                className="close_popup facnt full-round bgcolr6"
                onClick={() => setShow(false)}
              >
                {' '}
                <i className="fa fa-times txtcolr1"></i>
              </div>
              <div className="wrapper cover border_all_1 border_color_1 popup_scroll">
                <div className="cover marg_bottom10 mapping_history">
                  <div className="marg_bottom15 table_col table_fixed">
                    <div className="table_row bg2_8 border_color_1">
                      <div className="tabcel align_middle tu bld">Room Name</div>
                      <div className="tabcel align_middle tu bld">Markup Per</div>
                      <div className="tabcel align_middle tu bld">Markup Flat</div>
                      <div className="tabcel align_middle tu bld">Threshold</div>
                      <div className="tabcel align_middle tu bld">Decrease Invetory</div>
                      <div className="tabcel align_middle tu bld">User</div>
                      <div className="tabcel align_middle tu bld">Date</div>
                    </div>
                    {activityDetailsList()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ActivityLogWrapper;
